<mat-toolbar color="primary">
    <span>Traitement {{ treatment.type }}</span>
</mat-toolbar>
<mat-dialog-content>
    <div *ngIf="treatment?.key == 'SNItem.CNItem.CNTreatment.CNTreatmentKine'">
        <app-treatment-kine [treatment]="treatment"></app-treatment-kine>
    </div>
    <div *ngIf="treatment?.key == 'SNItem.CNItem.CNTreatment.CNTreatmentLogo'">
        <app-treatment-logo [treatment]="treatment"></app-treatment-logo>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
    <button mat-button mat-stroked-button (click)="save()">Sauvegarder</button>
</mat-dialog-actions>